import React, { Component } from 'react'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { snowplow, constants, compose } from 'common/helpers'

import { Button } from 'components/_new/controls'
import { openReviewModal } from 'compositions/modals/review'

import messages from './messages'


class ReviewButton extends Component {

  openModal = () => {
    const { data, isLoggedIn, urlToProduct, onEditReviewClick } = this.props
    const { reviewsData: { userReview }, id, img, name, brand, category, typeGroup } = data
    const reviewId = userReview ? userReview.id : null

    if (typeof onEditReviewClick === 'function') {
      onEditReviewClick()
      return
    }

    if (!userReview) {
      snowplow.track(constants.snowplowEvents.writeReviewClick, {
        productName: name,
        productId: id,
      })
    }
    else {
      snowplow.track(constants.snowplowEvents.editReviewClick, {
        productName: name,
        productId: id,
      })
    }

    if (isLoggedIn) {
      const onReviewSaved = (productId) => actions.view.productPage.fetchReviews(productId)

      if (typeGroup === constants.productTypeGroups.perfume) {
        // new perfume review
        openReviewModal({
          productId: id,
          placement: 'product page',
          onReviewSaved,
        })

        return
      }

      // legacy review
      actions.models.review.setProduct({ id, img, name, brand, category, typeGroup })

      if (userReview) {
        actions.models.modals.open(constants.modals.review.ReviewEdit, {
          userReview,
          onReviewEdited: onReviewSaved,
        })
      }
      else {
        actions.models.modals.open(constants.modals.review.ReviewComposer, {
          reviewId,
          onReviewAdded: onReviewSaved,
        })
      }
    }
    else {
      actions.models.modals.open(constants.modals.review.LoginRequired, {
        toWhatText: messages.modalText,
        urlToProduct: `${urlToProduct}?review`, // adding param 'review' to open review modal after login
      })
    }
  }

  render() {
    const { children, data: { reviewsData: { userReview } } } = this.props

    if (children) {
      return (
        React.cloneElement(children, {
          onClick: this.openModal,
        })
      )
    }

    return (
      <Button
        title={userReview ? messages.edit : messages.write}
        color="brand"
        size="md"
        fullWidth
        dataTestId="reviewButton"
        onClick={this.openModal}
      />
    )
  }
}


export default compose(
  connect({
    data: 'view.productPage',
    isLoggedIn: 'models.me.isLoggedIn',
    urlToProduct: 'routing.location.pathname',
  })
)(ReviewButton)
